import { c as _c } from "react/compiler-runtime";
import TransLoco from 'shared/components/trans-loco';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
export const useFormErrorMessageInTabs = () => {
  const $ = _c(3);
  const {
    t,
    tICU
  } = useLocoTranslation();
  let t0;
  if ($[0] !== t || $[1] !== tICU) {
    const formErrorMessage = t1 => {
      const {
        tabsErrorsMap,
        tabsLocoKeys
      } = t1;
      const tabsWithErrors = Object.entries(tabsErrorsMap).filter(_temp).map(_temp2);
      const errorMessage = tabsWithErrors.length ? <TransLoco t={key => {
        if (!key) {
          return;
        }
        return tICU(key, {
          tabs: tabsWithErrors.map(tab_0 => `"${t(tabsLocoKeys[tab_0] || "")}"`).join(", "),
          tabsCount: tabsWithErrors.length,
          b: _temp3
        });
      }} i18nKey="dashboard.store.error.check_following_errors_in_tab" components={{
        b: <b />
      }} /> : null;
      return {
        errorMessage
      };
    };
    t0 = {
      formErrorMessage
    };
    $[0] = t;
    $[1] = tICU;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  return t0;
};
function _temp(t0) {
  const [, hasError] = t0;
  return hasError;
}
function _temp2(t0) {
  const [tab] = t0;
  return tab;
}
function _temp3(elem) {
  return `<b>${elem.join()}</b>`;
}